/**
 * variant-cascade.js
 * ------------------------------------------------------------------
 * Kaskadierende Varianten-Auswahl für das Theme "Theme Update Juli 2026"
 * (Archetype/Empire mit <variant-selection> + <options-selection>).
 *
 * Markup, auf das dieses Script aufsetzt:
 *   <select data-variant-option data-variant-option-index="0|1|2">
 *     <option value="..." data-variant-option-value>
 *
 * Problem, das gelöst wird:
 *   Wählt man in Option 1 einen Wert, für den die aktuell gewählten
 *   Werte von Option 2/3 keine Variante ergeben, zeigt das Theme dort
 *   nur "Nicht verfügbar" - es schaltet NICHT automatisch auf eine
 *   existierende Kombination um.
 *
 * Lösung:
 *   Nach jeder Auswahl werden die nachfolgenden Ebenen geprüft. Ist der
 *   dort eingestellte Wert mit den vorherigen Auswahlen nicht kombinierbar,
 *   wird automatisch der erste passende Wert gesetzt (bevorzugt ein
 *   lieferbarer) und ein natives change-Event ausgelöst, damit die
 *   Theme-Logik Preis, Bild und Warenkorb-Variante aktualisiert.
 *
 * Die Optionslisten selbst werden NICHT verändert - dadurch bleibt die
 * Theme-eigene "Nicht verfügbar"-Kennzeichnung intakt.
 *
 * Robust: Event-Delegation auf document-Ebene (übersteht Re-Rendering),
 * ohne Produkt-JSON oder Dropdowns passiert nichts.
 * ------------------------------------------------------------------
 */
(function () {
  'use strict';

  var OPTION_SELECT = 'select[data-variant-option]';

  /** Produkt-JSON aus der Seite lesen. */
  function getProductJson() {
    var nodes = document.querySelectorAll(
      'script[data-variant-cascade], script[data-product-json], script[id^="ProductJson"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      try {
        var parsed = JSON.parse(nodes[i].textContent);
        if (parsed && parsed.variants && parsed.variants.length) return parsed;
      } catch (e) { /* nächste Quelle */ }
    }
    return null;
  }

  /** Options-Dropdowns frisch suchen, sortiert nach Options-Index. */
  function getOptionSelects() {
    var list = Array.prototype.slice.call(document.querySelectorAll(OPTION_SELECT));
    list.sort(function (a, b) {
      return Number(a.getAttribute('data-variant-option-index')) -
             Number(b.getAttribute('data-variant-option-index'));
    });
    return list;
  }

  /** Passt eine Variante zu den Auswahlen der Ebenen 0..level-1? */
  function matchesPrefix(variant, selections, level) {
    for (var l = 0; l < level; l++) {
      if (selections[l] == null) continue;
      if (variant['option' + (l + 1)] !== selections[l]) return false;
    }
    return true;
  }

  /**
   * Werte für Ebene "level", die mit den vorherigen Auswahlen eine
   * echte Variante ergeben. Lieferbare Werte zuerst.
   */
  function allowedValues(variants, selections, level) {
    var available = [];
    var existing = [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!matchesPrefix(v, selections, level)) continue;
      var val = v['option' + (level + 1)];
      if (val == null) continue;
      if (existing.indexOf(val) === -1) existing.push(val);
      if (v.available && available.indexOf(val) === -1) available.push(val);
    }
    return { available: available, existing: existing };
  }

  var product = null;
  var busy = false;

  /** Ebenen nach "fromLevel" auf eine gültige Kombination korrigieren. */
  function cascade(fromLevel) {
    if (busy || !product) return;
    var selects = getOptionSelects();
    var levels = Math.min(selects.length, 3);
    if (levels < 2) return; // Kaskade erst ab 2 Optionen sinnvoll

    busy = true;
    try {
      var selections = [];
      for (var l = 0; l < levels; l++) selections.push(selects[l].value || null);

      for (var lv = fromLevel + 1; lv < levels; lv++) {
        var allowed = allowedValues(product.variants, selections, lv);
        var current = selections[lv];
        var isOk = allowed.available.indexOf(current) !== -1 ||
                   (allowed.available.length === 0 && allowed.existing.indexOf(current) !== -1);
        if (isOk) continue;

        var target = allowed.available[0] || allowed.existing[0];
        if (!target) continue;

        // Wert nur setzen, wenn er im Dropdown vorhanden ist
        var exists = Array.prototype.some.call(selects[lv].options, function (o) {
          return o.value === target;
        });
        if (!exists) continue;

        selects[lv].value = target;
        selections[lv] = target;
        selects[lv].dispatchEvent(new Event('change', { bubbles: true }));
      }
    } finally {
      busy = false;
    }
  }

  function init() {
    product = getProductJson();
    if (!product) return;

    document.addEventListener('change', function (e) {
      if (busy) return;
      var t = e.target;
      if (!t || !t.matches || !t.matches(OPTION_SELECT)) return;
      var level = Number(t.getAttribute('data-variant-option-index'));
      if (!isNaN(level)) cascade(level);
    });

    // Initial einmal konsistent machen (das Theme rendert die Selects
    // erst per JS - daher leicht verzögert prüfen).
    setTimeout(function () { cascade(0); }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
